import { LiteTheme } from './LiteTheme';

var theme_ = new LiteTheme();

export default theme_;

